import { useEffect, useState } from 'react';
import { Box, Flex } from 'reflexbox';

import VoiceMemoControls from './VoiceMemoControls';
import VoiceMemoWaveForm from './VoiceMemoWaveForm';
import useVoiceMemoPlayer from './useVoiceMemoPlayer';

export default function VoiceMemoPlayback(props: {
	fromRecording?: boolean;
	source: Blob | string;
	samples: number[];
	onCancel?: () => void;
}) {
	const [playing, setPlaying] = useState(false);
	const [progress, setProgress] = useState(props.fromRecording ? 1.0 : 0.0);
	const [time, setTime] = useState(0.0);

	const player = useVoiceMemoPlayer({
		source: props.source,
		onPlay: () => setPlaying(true),
		onStop: () => setPlaying(false),
		onProgress: (progress, time) => {
			setProgress(progress);
			setTime(time);
		},
	});

	useEffect(() => {
		setTimeout(() => {
			setProgress(0.0);
		}, 100);
	}, []);

	return (
		<Flex flexDirection="column" alignItems="center" justifyContent="center" height="100%">
			<Box
				mt={2}
				width="100%"
				height="40px"
				style={{
					position: 'relative',
					overflow: 'hidden',
				}}
			>
				<Box
					style={{
						position: 'absolute',
						left: '50%',
						top: '50%',
						transform: `translate(-${progress * (props.samples.length * 6 - 4)}px, -50%)`,
						transition: '1s cubic-bezier(0, 1, 0, 1) transform',
					}}
				>
					<VoiceMemoWaveForm bars={props.samples} progress={progress} />
				</Box>
			</Box>
			<VoiceMemoControls
				status={playing ? 'playing' : 'paused'}
				time={time === 0.0 ? props.samples.length * 1000 : time * 1000}
				onPlay={() => player.play()}
				onPause={() => player.pause()}
				onCancel={props.onCancel}
			/>
		</Flex>
	);
}
